import { render } from "./PlanFromCatalogSelector.vue?vue&type=template&id=2160c34e&scoped=true&ts=true"
import script from "./PlanFromCatalogSelector.vue?vue&type=script&lang=ts"
export * from "./PlanFromCatalogSelector.vue?vue&type=script&lang=ts"

import "./PlanFromCatalogSelector.vue?vue&type=style&index=0&id=2160c34e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2160c34e"]])

export default __exports__